import { useCallback, useEffect, useState } from 'react';

import api from '../../api/api';
import { useAppContext } from '../../AppContext';
import { useUserContext } from '../../context/UserContext';
import { JwtToken } from '../../models/JwtToken';
import { useHttpFetchApi } from '../http/useHttpFetch';
import biometrics from '../../biometrics/biometrics';
import { Platform } from 'react-native';

export interface LoginDto {
  email: string;
  password: string;
  timeZone?: string;
}

export default function useLogin() {
  const { loading, error, postJson } = useHttpFetchApi();
  const { logError } = useAppContext();
  const { updateUserSession } = useUserContext();
  const [jwtToken, setJwtToken] = useState<JwtToken>();
  useEffect(
    () =>
      void (
        error &&
        error.statusCode !== 401 &&
        logError('Login Error', error)
      ),
    [error, logError]
  );
  const login = useCallback(
    async (loginDto: LoginDto) => {
      loginDto.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const jwt = await postJson<JwtToken>('users/login', loginDto);
      if (jwt?.accessToken) {
        if (Platform.OS !== 'web') {
          await biometrics.removeBiometricAccessToken();
        }
        await api.setAccessToken(jwt.accessToken);
        await updateUserSession();
        setJwtToken(jwt);
      }
    },
    [postJson, updateUserSession]
  );
  return {
    jwtToken,
    loadingUser: loading,
    loadingError: error,
    login
  };
}
